// PAYMENT VERIFICATIONS COPY ENUMS
export const PAYMENT_VERIFICATIONS_CONFIRM_MESSAGE = 'Please confirm your statement code';

export const PAYMENT_VERIFICATIONS_TOO_MANY_TRIES_MESSAGE =
  'You have entered a statement code incorrectly too many times. Send us a screenshot of your statement with the GOAT transaction and we can assist you.';

export const PAYMENT_VERIFICATIONS_NO_CODE_OR_ORDER_ERR =
  'You must input a statment code and have an order number to continue.';

export const PAYMENT_VERIFICATIONS_DISCLAIMER = (
  <span>
    By entering the statement code, I acknowledge that I have read and agreed to the purchase
    policy, that my billing and shipping information are accurate and that if international, I will
    be responsible for customs fees after the&nbsp;purchase.
  </span>
);

export const PAYMENT_VERIFICATIONS_DEFAULT_ERR_HEADER = 'Sorry, something went wrong.';

export const PAYMENT_VERIFICATIONS_ORDER_NOT_FOUND_MESSAGE =
  'Your order could not be located. Please contact us.';

// CSS ENUMS
export const PAYMENT_VERIFICATIONS_MAX_WIDTH = '480px';
export const PAYMENT_VERIFICATIONS_PHONE_GUTTER = '20px';
